import { Skeleton } from "../Skeleton"
import * as styles from "./skeleton-page.styled"
import type { SkeletonPageVariant } from "./skeleton-page.styled"

type SkeletonPageProps = {
  variant?: SkeletonPageVariant
}

export const SkeletonPage = ({ variant = "default" }: SkeletonPageProps) => (
  <div className={styles.wrapper(variant)}>
    <div className={styles.header}>
      <Skeleton className={styles.avatar} />
      <div className={styles.headerBlock}>
        <Skeleton className={styles.line1} />
        <Skeleton className={styles.line2} />
      </div>
    </div>
    <div className={styles.content}>
      <Skeleton className={styles.line3} />
      <Skeleton className={styles.line4} />
    </div>
    <Skeleton className={styles.line5} />
    <Skeleton className={styles.line6} />
  </div>
)
